import React from "react";
import { Chip, Tooltip } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { bool, string } from "prop-types";

const UnpublishedChip = ({
  unpublished = true,
  label = "Unpublished",
  size,
  tooltipTitle = null,
}) => {
  if (!unpublished) {
    return null;
  }

  const chip = (
    <Chip
      icon={<VisibilityOffIcon />}
      sx={(theme) => ({
        background: theme.palette.warning.main,
        border: "1px solid white",
        color: theme.palette.common.white,
        "& .MuiChip-icon": {
          color: theme.palette.common.white,
        },
      })}
      label={label}
      size={size || "medium"}
    />
  );

  if (tooltipTitle) {
    return <Tooltip title={tooltipTitle}>{chip}</Tooltip>;
  }

  return chip;
};

UnpublishedChip.propTypes = {
  unpublished: bool,
  label: string,
  size: string,
  tooltipTitle: string,
};

export default UnpublishedChip;
